import React from 'react'
import styled from '@emotion/styled'
import Flex from 'shared/library/atoms/Flex'
import Icon from 'shared/library/atoms/Icon'
import { Text } from 'library/atoms/Typography'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'

interface PoweredByEolaProps {
  variant?: 'checkout'
}

const PoweredByEola = ({ variant }: PoweredByEolaProps) => {
  const { t } = useTranslation('common')
  return (
    <>
      <StyledFlex gap={1} variant={variant}>
        {variant === 'checkout' ? (
          <>
            <Icon name="padlock" size={18} color="currentColor" />
            <Text fontStyle="p3">{t('powered-by-eola')}</Text>
          </>
        ) : (
          <>
            <Icon name="eola-logo-hexagonal" size={18} />
            <Text fontStyle="p4" color="tertiary">
              <Trans
                i18nKey="common:online-bookings-by-eola"
                components={[
                  <Text
                    key="pass-can-be-redeemed-count"
                    fontStyle="p4"
                    as="span"
                    color="black"
                  />
                ]}
                values={{ eola: 'eola' }}
              />
            </Text>
          </>
        )}
      </StyledFlex>
    </>
  )
}

export default PoweredByEola

const StyledFlex = styled(Flex)<Pick<PoweredByEolaProps, 'variant'>>(
  ({ theme }) => ({
    flexDirection: 'row',
    color: theme.colors.eola.greys[50],
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    position: 'relative',
    bottom: 0,
    marginTop: 'auto',
    textAlign: 'center',
    paddingTop: theme.space[9],
    paddingBottom: theme.space[6],
    svg: {
      use: {
        color: theme.colors.eola.greys[50]
      }
    }
  }),
  ({ variant, theme }) =>
    variant === 'checkout' && {
      paddingTop: theme.space[4],
      paddingBottom: 0
    }
)
